import React, { useState, useEffect } from "react";
import axios from "axios";
import "./style.css";
import Header from "../../components/header";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export default function Terms() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/privacy-terms/terms`);
        setContent(response.data.content);
        setLastUpdated(response.data.lastUpdated);
      } catch (error) {
        console.error("Error fetching terms of service:", error);
        // Fallback to default content if API fails
        setContent(null);
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  // Default content fallback
  const defaultContent = `
    <section class="terms_section">
      <h2>1. Acceptance of Terms</h2>
      <div class="section_content">
        <p>Welcome to UsmaApp! By accessing or using our services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use our services.</p>
      </div>
    </section>
    <section class="terms_section">
      <h2>2. Description of Service</h2>
      <div class="section_content">
        <p>UsmaApp is a social networking platform that allows users to:</p>
        <ul>
          <li>Create and customize personal profiles</li>
          <li>Connect with friends and other users</li>
          <li>Share content including posts, photos, videos, and stories</li>
          <li>Send messages and communicate with other users</li>
          <li>Join groups and communities</li>
          <li>Discover and interact with content from other users</li>
          <li>Access marketplace features</li>
        </ul>
      </div>
    </section>
    <section class="terms_section">
      <h2>3. User Accounts and Registration</h2>
      <div class="section_content">
        <p>To use UsmaApp, you must create an account. You agree to:</p>
        <ul>
          <li>Provide accurate, current, and complete information</li>
          <li>Maintain and update your account information</li>
          <li>Not share your account with others</li>
          <li>Be at least 18 years old (or the minimum age in your jurisdiction)</li>
        </ul>
        <p>You are responsible for all activities that occur under your account.</p>
      </div>
    </section>
    <section class="terms_section">
      <h2>4. Privacy and Data Protection</h2>
      <div class="section_content">
        <p>Your privacy is important to us. Our Privacy Policy explains how we collect, use, and protect your information. By using UsmaApp, you agree to our data practices as described in our Privacy Policy.</p>
        <p>Key privacy principles:</p>
        <ul>
          <li>We don't sell your personal information</li>
          <li>You control your privacy settings</li>
          <li>You can delete your account and data at any time</li>
        </ul>
      </div>
    </section>
    <section class="terms_section">
      <h2>5. Safety and Security</h2>
      <div class="section_content">
        <p>We are committed to maintaining a safe environment for all users:</p>
        <ul>
          <li><strong>Reporting:</strong> Report harmful content or behavior immediately</li>
          <li><strong>Blocking:</strong> Use blocking features to avoid unwanted interactions</li>
          <li><strong>Privacy Controls:</strong> Adjust your privacy settings regularly</li>
        </ul>
      </div>
    </section>
    <section class="terms_section">
      <h2>6. Changes to Terms</h2>
      <div class="section_content">
        <p>We may update these Terms from time to time. We will notify you of material changes by:</p>
        <ul>
          <li>Posting the updated Terms on our platform</li>
          <li>Sending you a notification through UsmaApp</li>
          <li>Updating the "Last updated" date</li>
        </ul>
      </div>
    </section>
       <section className="terms_section">
              <h2>7. Contact Information</h2>
              <div className="section_content">
                <p>If you have questions about these Terms of Service, please contact us:</p>
                <div className="contact_info">
                  <p><strong>Support:</strong> support@usmaapp.com</p>
                </div>
              </div>
            </section>
          </div>
  `;

  if (loading) {
    return (
      <div className="terms_page">
        <Header />
        <div className="terms_container">
          <div className="terms_content">
            <p>Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="terms_page">
      <Header />
      <div className="terms_container">
        <div className="terms_content">
          <div className="terms_header">
            <h1>UsmaApp Terms of Service</h1>
            {lastUpdated && (
              <p className="last_updated">
                Last updated: {new Date(lastUpdated).toLocaleDateString()}
              </p>
            )}
          </div>

          <div className="terms_sections" dangerouslySetInnerHTML={{ __html: content || defaultContent }}></div>

          <div className="terms_footer">
            <p><strong>UsmaApp</strong> - Building connections, fostering community.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
